module.exports = __webpack_public_path__ + "static/media/addToGoogleWallet.b7de6257.svg";